import { render } from "./ISharedFolderMultiPicker.vue?vue&type=template&id=324a387b"
import script from "./ISharedFolderMultiPicker.vue?vue&type=script&lang=js"
export * from "./ISharedFolderMultiPicker.vue?vue&type=script&lang=js"

import "./ISharedFolderMultiPicker.vue?vue&type=style&index=0&id=324a387b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__